import { Component, inject, OnInit, Signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { BreadcrumbsComponent } from '../../../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../../../components/content/content.component';
import { CommonModule } from '@angular/common';
import {
  PaymentStatusCheckerComponent
} from '../../../../common/payment-status-checker/payment-status-checker.component';
import { Store } from '@ngrx/store';
import { loadPayment } from '../../../../store/actions/my-bills.actions';
import { SigIdPaymentComponentRead, SigIdPaymentRead } from '../../../../services/sig-id.common.model';
import {
  selectLoading,
  selectPayment,
  selectPaymentComponentByIdZap
} from '../../../../store/selectors/my-bills.selectors';
import { AlertComponent } from '../../../../common/alert/alert.component';

@Component({
  selector: 'app-my-bills-payment-status-page',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    ContentComponent,
    CommonModule,
    PaymentStatusCheckerComponent,
    RouterLink,
    AlertComponent
  ],
  templateUrl: './my-bills-payment-status-page.component.html'
})
export class MyBillsPaymentStatusPageComponent implements OnInit {

  private route: ActivatedRoute = inject(ActivatedRoute);

  private store$: Store = inject(Store);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public payment: Signal<SigIdPaymentRead | null> = this.store$.selectSignal(selectPayment);

  public paymentToken: string | undefined = this.route.snapshot.queryParams['payment_token'] || this.route.snapshot.queryParams['payum_token'];

  public identSigId: string = this.route.snapshot.params['identSigId'];

  public serviceCode: string = this.route.snapshot.params['serviceCode'];

  public idZap: string | undefined = this.route.snapshot.params['idZap'];

  public paymentComponent: Signal<SigIdPaymentComponentRead | null> = this.store$.selectSignal(selectPaymentComponentByIdZap(this.idZap));

  public get goBackUrl(): string[] {
    return ['/moje-oplaty/', this.identSigId, this.serviceCode, this.idZap || ''].filter(v => !!v);
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadPayment({
      identSigId: this.identSigId,
      serviceCode: this.serviceCode
    }));
  }

}
